import { useEffect } from 'react'

import { useTimelineContext } from '../hooks/useTimelineContext'

export const RegisterEditFunction = (props: {
    onRegister: (editFn: (userId: string) => void) => void
}) => {
    const timelineContext = useTimelineContext()

    useEffect(() => {
        const { onRegister } = props
        if (onRegister && timelineContext) {
            onRegister((userId: string) => {
                try {
                    const lastUserMessage = timelineContext.events
                        .slice()
                        .reverse()
                        .find((event) => event.sender.id === userId)

                    if (lastUserMessage && timelineContext.timelineActions) {
                        timelineContext.timelineActions.onSelectEditingMessage(
                            lastUserMessage.eventId,
                        )
                        return true
                    }
                } catch (error) {
                    console.error('Error finding last message', error)
                }
                return false
            })
        }
    }, [props, timelineContext])

    return null
}
